/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
import { useSelector, useDispatch } from 'react-redux';
import React from 'react';
// react library for routing
import { useLocation, useHistory, Route, Switch, Redirect } from 'react-router-dom';

// core components
import AuthNavbar from 'components/Navbars/AuthNavbar';
import AuthFooter from 'components/Footers/PhuongNam/AuthFooter';

import routes from 'routes';
import { init } from 'modules/Auth/actions';

function Auth() {
  const history = useHistory();
  const loggedInUser = useSelector((state) => state.authReducer.loggedInUser);
  const dispatch = useDispatch();
  const location = useLocation();
  const mainContentRef = React.useRef(null);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
    document.body.classList.add('bg-default');
    // Specify how to clean up after this effect:
    return function cleanup() {
      document.body.classList.remove('bg-default');
    };
  });

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (props) => {
    return props.map((prop, index) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === '/auth') {
        return <Route path={prop.layout + prop.path} component={prop.component} key={index} />;
      }
      return null;
    });
  };

  React.useEffect(() => {
    if (loggedInUser) {
      history.push('/lms/home');
    } else {
      dispatch(init());
    }
  }, [dispatch, history, loggedInUser]);

  return (
    <>
      <div className='main-content' ref={mainContentRef}>
        <AuthNavbar />
        <Switch>
          {getRoutes(routes)}
          <Redirect from='*' to='/' />
        </Switch>
      </div>
      <AuthFooter />
    </>
  );
}

export default Auth;
